import { useEffect, useState } from 'react'

import { equals } from 'ramda'

import ChonkersJPG from 'assets/images/chonkers.jpg'

/**
 * Hello there. I see you've stumbled upon this file. If you manage
 * to activate the secret easter egg I've put in the app, DM me with
 * the proof and I'll invite you to the secret slack channel (;
 *
 * Also please keep this a secret. It'll be the most hipster of
 * easter eggs!
 *
 * To begin activating, click on an empty area in the nav bar at the
 * top and tab to the correct element. You'll know you're at the
 * right element when you see green focus highlighting.
 */

const KEY_TIMEOUT = 1000
// https://en.wikipedia.org/wiki/Konami_Code
const CHEAT_CODE = [
  'ArrowUp',
  'ArrowUp',
  'ArrowDown',
  'ArrowDown',
  'ArrowLeft',
  'ArrowRight',
  'ArrowLeft',
  'ArrowRight',
  'b',
  'a',
]

const useCheatCode = () => {
  const [buffer, setBuffer] = useState<string[]>([])
  const [lastKeyTime, setLastKeyTime] = useState(Date.now())
  const [isSecretUnlocked, setIsSecretUnlocked] = useState(false)

  const handleKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    const currentTime = Date.now()

    if (currentTime - lastKeyTime > KEY_TIMEOUT) {
      setBuffer([e.key])
    } else {
      setBuffer([...buffer, e.key])
    }

    setLastKeyTime(currentTime)
  }

  useEffect(() => {
    if (equals(CHEAT_CODE, buffer)) {
      setIsSecretUnlocked(true)
    }
  }, [buffer])

  return {
    buffer,
    handleKeyDown,
    secretImg: isSecretUnlocked ? ChonkersJPG : null,
  }
}

export { useCheatCode }
